module.exports = "https://cdn.dove.it/_next/static/public/assets/services/promozione_430.b4057f2bde1397fa521936e88eeb5ef7.jpg";